import { siteAddress, isDssPreview } from '@/utilities/site.js'

const api = siteAddress + '/api/content/x121475/elements/SitewideMegaMenuItems/'
// console.log(api)

const processDefaultDssApiRoute = async data => {
  let menus = []

  let getMenu = (rawMenu) => {
    let menu = {
      name: '',
      excerpt: '',
      lists: [],
      promo: {
        exerpt: '',
        icon: '',
        url: ''
      }
    }

    for (let prop of rawMenu) {
      switch (prop.name) {
        case 'Name':
          menu.name = prop.value
        break

        case 'Excerpt':
        case 'MobileExcerpt':
          menu.excerpt = prop.value
        break

        case 'MainColumnLinkListComponent':
          menu.lists.push(getList(prop.children))
        break
       
        case 'PromotionIcon':
          menu.promo.icon = prop.value
        break

        case 'PromotionExcerpt':
          menu.promo.excerpt = prop.value
        break

        case 'Page':
          menu.promo.url = prop.attributes.url
        break
      }
    }
    
    return menu
  }
  
  let getList = (rawList) => {
    let list = {
      header: {
        name: ''
      },
      links: []
    }

    for (let prop of rawList) {
      switch (prop.name) {
        case 'Title':
          list.header.name = prop.value
        break

        case 'Page':
          if (prop.attributes.name === 'TitleLink') {
            delete prop.attributes.name

            list.header = {
              ...list.header,
              ...prop.attributes
            }
          } else {
            list.links.push(prop.attributes)
          }
        break
      }
    }

    return list
  }

  for (let menu of data) {
    menus.push(getMenu(menu.children))
  }

  // console.log('Raw IGX Menu Data: ', data) /* eslint-disable-line */
  // console.log('Compressed Menu Data: ', menus) /* eslint-disable-line */

  return menus
}

const getData = async () => {
  try {
    const response = await fetch(api, { cache: 'force-cache' }),
          data = await response.json()

    // console.log('fetch response: ', response)
    // console.log('fetch data: ', data)

    return data
  } catch (err) {
    console.log('Mega Menu API Source failed: ', err) /* eslint-disable-line */

    if (isDssPreview) console.log( `But it's okay. The DSS Preview doesn't have a DSSAPI.`)
    return null
  }
}

async function getMenus() {
  const rawMenu = await getData() 

  let menus = (rawMenu) ? await processDefaultDssApiRoute(rawMenu.elements) : null

  // console.log('Menus: ', menus) /* eslint-disable-line */
  return menus
}

export default { 
  getMenus 
}